module.exports = __webpack_public_path__ + "static/media/CF.db4a5cea.jpg";